import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import React, { useEffect, useState } from "react";
import { Container } from "./Container";
// Components
import AlertDialog from "components/Dialog/index";
import RightDrawer from "components/drawer/index";
import Loader from "components/loader/Loader";
import MyModal from "components/MyModal";
import { setLocalizationMoment } from "helper/dateFormat";
import useNotificationSocket from "hook/useNotificationSocket";
import { Header } from "./Header";
import { CheckValidUser } from "./LogoutWrapper";
import { Main } from "./Main";
import AddNotify from "./Notifications/AddNotify";
import NotificationSettings from "./NotificationSettings/NotificationSettings";

export const AppLayout = ({ children, isDonationLayout, ...rest }) => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [checkMember, setMember] = useState();
  const [loading, setLoading] = useState(true);
  const [openAddNotify, setOpenAddNotify] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [openNotificationSettings, setOpenNotificationSettings] = useState(false);
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
  );
  
  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      localStorage.setItem("token", token);
      AuthService.getUserExist(token)
        .then((res) => {
          setMember(res);
          localStorage.setItem(
            "organization",
            JSON.stringify(res?.user?.permissions?.organization)
          );
          localStorage.setItem(
            "authorizedModules",
            JSON.stringify(res?.user?.permissions?.authorizedModules)
          );
          localStorage.setItem(
            "orgAuthorizedModules",
            JSON.stringify(res?.user?.permissions?.organization?.authorizedModules)
          );
          localStorage.setItem("firstName", JSON.stringify(res?.user?.permissions?.linked_contact?.first_name ?res?.user?.permissions?.linked_contact?.first_name : user.nickname ));
          localStorage.setItem("lastName", JSON.stringify(res?.user?.permissions?.linked_contact?.last_name ?res?.user?.permissions?.linked_contact?.last_name :""));
          localStorage.setItem("email_address", JSON.stringify(res?.user?.permissions?.linked_contact?.email_address ? res?.user?.permissions?.linked_contact?.email_address : user.email));
          localStorage.setItem("user_profile_img", JSON.stringify(res?.user?.permissions?.linked_contact?.profile_img ? res?.user?.permissions?.linked_contact?.profile_img : user.picture));
          localStorage.setItem("user_contact_id", JSON.stringify(res?.user?.permissions?.linked_contact?._id ? res?.user?.permissions?.linked_contact?._id : ""));
          localStorage.setItem("notificationSound",  JSON.stringify(!res?.user?.notificationSound ? true : res?.user?.notificationSound));
          document.title = res?.user?.permissions?.organization?.orgName ?? "Temple Shalom";
          setLoading(false);
          const generalOptions = res?.user?.permissions?.organization?.generalOptions;
          const generalOptionsObj = generalOptions.reduce((acc, item) => {
            acc[item.title] = {
              hidden: item.hidden,
              options: item.options
            };
            return acc;
          }
          , {});
          const deceasedRelationship = res?.user?.permissions?.organization?.deceasedRelationship?.options || [];
          localStorage.setItem("generalOptions", JSON.stringify(generalOptionsObj));
          localStorage.setItem("deceasedRelationship", JSON.stringify(deceasedRelationship));
        })
        .catch((err) => {
          setMember(err);
          setLoading(false);
        });
    }
    if(!isAuthenticated) return setLoading(false);
    fetchMyAPI();
  }, []);


  useEffect(() => {
    if (orgData?.country?.code) {
      setLocalizationMoment(orgData?.country?.local);
    }
  }, [orgData?.country?.code])
  

  const openAddNotifyHandler = () => {
    setOpenAddNotify(true);
  }

  const closeAddNotifyHandler = () => {
    setOpenAddNotify(false);
  }

  const openNotificationSettingsHandler = () => {
    setOpenNotificationSettings(true);
  }

  const closeNotificationSettingsHandler = (close = false) => {
    if (close) {
      return setOpenNotificationSettings(false);
    } 
    setConfirmClose(true);
  }


  const { isLoading: isNotificationLoading, notifications,totalNotifications, markAsRead,markAllAsRead,fetchMoreNotifications, hasMore } = useNotificationSocket({
    getAccessTokenSilently,
    checkMember,
  });

  const closeModal = (close = false) => {
    if (close) {
      return closeAddNotifyHandler(true);
    } 
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    closeAddNotifyHandler()
    setOpenNotificationSettings(false);
  }



  if (loading)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <Loader />
      </div>
    );
  if (isDonationLayout) { 
    return (
      <Container {...rest}>
        <>
          {children}
        </>
      </Container>
    );
  }
  return checkMember?.data?.exists === false ? (
    <CheckValidUser />
  ) : checkMember?.exists &&
    Boolean(checkMember?.user?.permissions?.permissionType) &&
    checkMember?.user?.permissions?.permissionType !== "org_admin" ? (
    <CheckValidUser />
  ) : (
    <Container {...rest}>
      <>
        <Header 
          openAddNotify={openAddNotifyHandler} 
          openNotificationSettings={openNotificationSettingsHandler} 
          isNotificationLoading={isNotificationLoading} 
          notifications={notifications} 
          totalNotifications={totalNotifications} 
          markAsRead={markAsRead} 
          markAllAsRead={markAllAsRead} 
          fetchMoreNotifications={fetchMoreNotifications} 
          hasMore={hasMore} 
        />
        <Main>{children}</Main>
      </>
      <MyModal
        className="add-notify__modal"
        open={openAddNotify}
        onClose={() => closeModal()}
      >
        <AddNotify onClose={closeModal} />
      </MyModal>
      <RightDrawer
        open={openNotificationSettings}
        onClose={() => closeNotificationSettingsHandler()}
      >
        <NotificationSettings 
          onClose={closeNotificationSettingsHandler}
        />
      </RightDrawer>
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </Container>
  );
};
